/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutAdminIndexRouteImport } from './routes/_layout/admin/index'
import { Route as LayoutAdminRolesRouteImport } from './routes/_layout/admin/roles'
import { Route as LayoutAdminMarketingTemplatesRouteImport } from './routes/_layout/admin/marketing-templates'
import { Route as LayoutAdminMarketingLeadsRouteImport } from './routes/_layout/admin/marketing-leads'
import { Route as LayoutAdminMarketingCampaignsRouteImport } from './routes/_layout/admin/marketing-campaigns'
import { Route as LayoutAdminLicensesRouteImport } from './routes/_layout/admin/licenses'
import { Route as LayoutAdminCustomersRouteImport } from './routes/_layout/admin/customers'
import { Route as LayoutAdminCustomersCustomerIdRouteImport } from './routes/_layout/admin/customers.$customerId'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminIndexRoute = LayoutAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminRolesRoute = LayoutAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminMarketingTemplatesRoute =
  LayoutAdminMarketingTemplatesRouteImport.update({
    id: '/admin/marketing-templates',
    path: '/admin/marketing-templates',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAdminMarketingLeadsRoute =
  LayoutAdminMarketingLeadsRouteImport.update({
    id: '/admin/marketing-leads',
    path: '/admin/marketing-leads',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAdminMarketingCampaignsRoute =
  LayoutAdminMarketingCampaignsRouteImport.update({
    id: '/admin/marketing-campaigns',
    path: '/admin/marketing-campaigns',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAdminLicensesRoute = LayoutAdminLicensesRouteImport.update({
  id: '/admin/licenses',
  path: '/admin/licenses',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminCustomersRoute = LayoutAdminCustomersRouteImport.update({
  id: '/admin/customers',
  path: '/admin/customers',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminCustomersCustomerIdRoute =
  LayoutAdminCustomersCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => LayoutAdminCustomersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/settings': typeof LayoutSettingsRoute
  '/admin/customers': typeof LayoutAdminCustomersRouteWithChildren
  '/admin/licenses': typeof LayoutAdminLicensesRoute
  '/admin/marketing-campaigns': typeof LayoutAdminMarketingCampaignsRoute
  '/admin/marketing-leads': typeof LayoutAdminMarketingLeadsRoute
  '/admin/marketing-templates': typeof LayoutAdminMarketingTemplatesRoute
  '/admin/roles': typeof LayoutAdminRolesRoute
  '/admin/': typeof LayoutAdminIndexRoute
  '/admin/customers/$customerId': typeof LayoutAdminCustomersCustomerIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/settings': typeof LayoutSettingsRoute
  '/': typeof LayoutIndexRoute
  '/admin/customers': typeof LayoutAdminCustomersRouteWithChildren
  '/admin/licenses': typeof LayoutAdminLicensesRoute
  '/admin/marketing-campaigns': typeof LayoutAdminMarketingCampaignsRoute
  '/admin/marketing-leads': typeof LayoutAdminMarketingLeadsRoute
  '/admin/marketing-templates': typeof LayoutAdminMarketingTemplatesRoute
  '/admin/roles': typeof LayoutAdminRolesRoute
  '/admin': typeof LayoutAdminIndexRoute
  '/admin/customers/$customerId': typeof LayoutAdminCustomersCustomerIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/admin/customers': typeof LayoutAdminCustomersRouteWithChildren
  '/_layout/admin/licenses': typeof LayoutAdminLicensesRoute
  '/_layout/admin/marketing-campaigns': typeof LayoutAdminMarketingCampaignsRoute
  '/_layout/admin/marketing-leads': typeof LayoutAdminMarketingLeadsRoute
  '/_layout/admin/marketing-templates': typeof LayoutAdminMarketingTemplatesRoute
  '/_layout/admin/roles': typeof LayoutAdminRolesRoute
  '/_layout/admin/': typeof LayoutAdminIndexRoute
  '/_layout/admin/customers/$customerId': typeof LayoutAdminCustomersCustomerIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/unsubscribe'
    | '/settings'
    | '/admin/customers'
    | '/admin/licenses'
    | '/admin/marketing-campaigns'
    | '/admin/marketing-leads'
    | '/admin/marketing-templates'
    | '/admin/roles'
    | '/admin/'
    | '/admin/customers/$customerId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/unsubscribe'
    | '/settings'
    | '/'
    | '/admin/customers'
    | '/admin/licenses'
    | '/admin/marketing-campaigns'
    | '/admin/marketing-leads'
    | '/admin/marketing-templates'
    | '/admin/roles'
    | '/admin'
    | '/admin/customers/$customerId'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/unsubscribe'
    | '/_layout/settings'
    | '/_layout/'
    | '/_layout/admin/customers'
    | '/_layout/admin/licenses'
    | '/_layout/admin/marketing-campaigns'
    | '/_layout/admin/marketing-leads'
    | '/_layout/admin/marketing-templates'
    | '/_layout/admin/roles'
    | '/_layout/admin/'
    | '/_layout/admin/customers/$customerId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/': {
      id: '/_layout/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof LayoutAdminIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/roles': {
      id: '/_layout/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof LayoutAdminRolesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/marketing-templates': {
      id: '/_layout/admin/marketing-templates'
      path: '/admin/marketing-templates'
      fullPath: '/admin/marketing-templates'
      preLoaderRoute: typeof LayoutAdminMarketingTemplatesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/marketing-leads': {
      id: '/_layout/admin/marketing-leads'
      path: '/admin/marketing-leads'
      fullPath: '/admin/marketing-leads'
      preLoaderRoute: typeof LayoutAdminMarketingLeadsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/marketing-campaigns': {
      id: '/_layout/admin/marketing-campaigns'
      path: '/admin/marketing-campaigns'
      fullPath: '/admin/marketing-campaigns'
      preLoaderRoute: typeof LayoutAdminMarketingCampaignsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/licenses': {
      id: '/_layout/admin/licenses'
      path: '/admin/licenses'
      fullPath: '/admin/licenses'
      preLoaderRoute: typeof LayoutAdminLicensesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/customers': {
      id: '/_layout/admin/customers'
      path: '/admin/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof LayoutAdminCustomersRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/customers/$customerId': {
      id: '/_layout/admin/customers/$customerId'
      path: '/$customerId'
      fullPath: '/admin/customers/$customerId'
      preLoaderRoute: typeof LayoutAdminCustomersCustomerIdRouteImport
      parentRoute: typeof LayoutAdminCustomersRoute
    }
  }
}

interface LayoutAdminCustomersRouteChildren {
  LayoutAdminCustomersCustomerIdRoute: typeof LayoutAdminCustomersCustomerIdRoute
}

const LayoutAdminCustomersRouteChildren: LayoutAdminCustomersRouteChildren = {
  LayoutAdminCustomersCustomerIdRoute: LayoutAdminCustomersCustomerIdRoute,
}

const LayoutAdminCustomersRouteWithChildren =
  LayoutAdminCustomersRoute._addFileChildren(LayoutAdminCustomersRouteChildren)

interface LayoutRouteChildren {
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutAdminCustomersRoute: typeof LayoutAdminCustomersRouteWithChildren
  LayoutAdminLicensesRoute: typeof LayoutAdminLicensesRoute
  LayoutAdminMarketingCampaignsRoute: typeof LayoutAdminMarketingCampaignsRoute
  LayoutAdminMarketingLeadsRoute: typeof LayoutAdminMarketingLeadsRoute
  LayoutAdminMarketingTemplatesRoute: typeof LayoutAdminMarketingTemplatesRoute
  LayoutAdminRolesRoute: typeof LayoutAdminRolesRoute
  LayoutAdminIndexRoute: typeof LayoutAdminIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutAdminCustomersRoute: LayoutAdminCustomersRouteWithChildren,
  LayoutAdminLicensesRoute: LayoutAdminLicensesRoute,
  LayoutAdminMarketingCampaignsRoute: LayoutAdminMarketingCampaignsRoute,
  LayoutAdminMarketingLeadsRoute: LayoutAdminMarketingLeadsRoute,
  LayoutAdminMarketingTemplatesRoute: LayoutAdminMarketingTemplatesRoute,
  LayoutAdminRolesRoute: LayoutAdminRolesRoute,
  LayoutAdminIndexRoute: LayoutAdminIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  UnsubscribeRoute: UnsubscribeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
